import React from 'react';
import { Hidden, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import BaseLayout from './BaseLayout';

const useStyles: any = makeStyles((theme: any) => ({
  container: {
    padding: theme.spacing(4),
  },
  mainContent: {
    border: `1px solid ${theme.palette.grey['300']}`,
    borderRadius: 4,
  },
  pageTitle: {
    padding: theme.spacing(0, 0, 2),
  },
}));

interface Props {
  children: React.ReactNode;
  pageTitle: string;
}

const PageLayout = (props: Props) => {
  const classes = useStyles();
  const { children, pageTitle } = props;

  return (
    <BaseLayout>
      <Hidden xsDown>
        <Paper className={classes.container}>
          <Typography variant='h3' className={classes.pageTitle}>
            {pageTitle}
          </Typography>
          <main className={classes.mainContent}>{children}</main>
        </Paper>
      </Hidden>
      <Hidden smUp>
        {pageTitle && (
          <Typography variant='h3' className={classes.pageTitle}>
            {pageTitle}
          </Typography>
        )}
        <main className={classes.mainContent}>{children}</main>
      </Hidden>
    </BaseLayout>
  );
};

export default PageLayout;
